import { Button, Form, Input , Col, message , Row } from 'antd';
import React, { Component } from 'react';
import axios from 'axios'
import TopBrandBar from '../components/TopBrandBar';
import TopNavBar from '../components/TopNavBar';


class EditCustomerForm extends Component {
    constructor(props) {
        super(props);
        this.state = { 
            customer :  {
                contact : {
                    firstName : "First Name",
                    address : {}
                }
            }
         }
    }

    componentDidMount(){
        message.loading("Loading ....")
        console.log(this.props.match.params.id)
        axios.get(`/api/user/customers/${this.props.match.params.id}`)
        .then(
            response => {
               const contact = {
                   firstName : response.data.contact.FirstName,
                   lastName : response.data.contact.LastName,
                   phoneNo1 : response.data.contact.ContactNo,
                   phoneNo2 : response.data.contact.MobileNo,
                   address : {
                       no : response.data.contact.Address.No,
                       street : response.data.contact.Address.Street,
                       town : response.data.contact.Address.Town,
                       district : response.data.contact.Address.District,
                   }

               }

               this.setState({
                   customer : { 
                       contact : contact
                   }
               }, ()=> {
                   message.destroy()
                }
               )
            }
        )
        .catch(
            er => {
                console.log(er)
                message.destroy()
            }
        )
    }

    onSave = (e)=> {
        e.preventDefault()
        this.props.form.validateFields(
            (err,values)=> {
                if(!err){
                    console.log(values)
                    this.setState({
                        loading : true
                    },
                    ()=> {
                        axios.patch(`/api/user/customers/${this.props.match.params.id}`,{
                            contact: {
                                FirstName: values.firstName,
                                LastName : values.lastName,
                                ContactNo : values.phoneNo1,
                                MobileNo : values.phoneNo2,
                                Address : {
                                    No: values.address_no,
                                    Street: values.address_street,
                                    Town: values.address_town,
                                    District: values.address_district,
                                }
                            }
                        })
                        .then(
                            response => {
                                this.setState({
                                    loading : false
                                } , ()=> {
                                    this.props.onCustomerEdit()
                                })
                            }
                        )
                        .catch(e=>{
                            console.error(e)
                            this.setState({
                                loading : false
                            })
                        })
                    }
                    )
                   
                }
            }
        )
    }

    render() { 
        const { getFieldDecorator, getFieldsError, getFieldError, isFieldTouched } = this.props.form;
        return (
            <Form labelCol={{span:8}} wrapperCol={{span:16}} onSubmit={this.onSave}>
                <Form.Item labelAlign="left"  label="First Name">
                    {
                        getFieldDecorator("firstName",
                        {   
                            rules: [{ required: true, message: 'Please input customer first name!' }],
                            initialValue : this.state.customer.contact.firstName
                        }
                        )(<Input />)
                    }
                </Form.Item>
                <Form.Item  labelAlign="left"  label="Last Name">
                    {
                        getFieldDecorator("lastName",
                        {   
                            rules: [{ required: true, message: 'Please input customer last name!' }],
                            initialValue : this.state.customer.contact.lastName
                        }
                        )(<Input />)
                    }
                </Form.Item>
                {/* Address --- */}
                <Form.Item labelAlign="left"  label="No">
                    {
                        getFieldDecorator("address_no",
                        {   
                            rules: [{ required: true, message: 'Please input address no cannot be empty' }],
                            initialValue : this.state.customer.contact.address.no
                        }
                        )(<Input />)
                    }
                </Form.Item>
                <Form.Item labelAlign="left"  label="street">
                    {
                        getFieldDecorator("address_street",
                        {   
                            rules: [{ required: true, message: 'Please input address no cannot be empty' }],
                            initialValue : this.state.customer.contact.address.street
                        }
                        )(<Input />)
                    }
                </Form.Item>
                <Form.Item labelAlign="left"  label="town">
                    {
                        getFieldDecorator("address_town",
                        {   
                            rules: [{ required: true, message: 'Please input address no cannot be empty' }],
                            initialValue : this.state.customer.contact.address.town
                        }
                        )(<Input />)
                    }
                </Form.Item>
                <Form.Item  labelAlign="left"  label="District">
                    {
                        getFieldDecorator("address_district",
                        {   
                            rules: [{ required: true, message: 'Please input address no cannot be empty' }],
                            initialValue : this.state.customer.contact.address.district
                        }
                        )(<Input />)
                    }
                </Form.Item>
                <Form.Item labelAlign="left"  label="Contact No">
                    {
                        getFieldDecorator("phoneNo1",
                        {   
                            rules: [{ required: true, message: 'Please input address no cannot be empty' }],
                            initialValue : this.state.customer.contact.phoneNo1
                        }
                        )(<Input />)
                    }
                </Form.Item>
                <Form.Item labelAlign="left"  label="Mobile No">
                    {
                        getFieldDecorator("phoneNo2",
                        {   
                            rules: [{ required: true, message: 'Please input address no cannot be empty' }],
                            initialValue : this.state.customer.contact.phoneNo2
                        }
                        )(<Input />)
                    }
                </Form.Item>
            
                <Col ><Button loading={this.state.loading} block type="primary" htmlType="submit">Save Customer</Button></Col>
             
            </Form>
          );
    }
}

const EditCustomerFormWrapper = Form.create({"name":"edit_customer"})(EditCustomerForm)

function EditCustomer(props){
    const navigate = (link) =>{
        props.history.push(link)
    }
    return (
        <>
         <TopNavBar navigate={navigate} title={"Dashboard"}/>
         <Row style={{marginTop:"50px"}}>
             <Col offset={2} span={20}>
                <EditCustomerFormWrapper navigate={navigate} {...props}/>
            </Col>
         </Row>
        </>
    )
}

 
export default EditCustomerFormWrapper;